import React from 'react';
import { Navigate } from 'react-router-dom';

import ROUTERS_PATHS from 'consts/router-paths';
import ConfirmModal from 'components/ConfirmModal';
import useAuth from 'contexts/useAuth';

interface AuthGuardProps {
  children: React.ReactNode;
}

const AdminGuard = (props: AuthGuardProps) => {
  const { children } = props;
  const { role } = useAuth();

  if (['Administrator', 'Editor'].includes(role)) {
    return (
      <>
        {children}
        <ConfirmModal />
      </>
    );
  }

  return <Navigate to={ROUTERS_PATHS.LOGIN} replace />;
};

export default AdminGuard;
